import { useMemo } from 'react'
import { useMediaQuery } from 'react-responsive'

const StatsBanner = ({ gridsToday, correctGrids, closeSession, started }) => {
  const correctGridsString = useMemo(
    () =>
      gridsToday === 0
        ? '-'
        : Math.floor((correctGrids / gridsToday) * 100) + '%',
    [gridsToday, correctGrids],
  )

  const isMobile = useMediaQuery({
    query: '(max-width:1024px)',
  })

  return gridsToday !== undefined && correctGrids !== undefined ? (
    <div
      className={`rounded bg-secondary-background text-over-secondary-background fixed mx-auto inset-x-0 w-1/6 min-w-[200px] h-[50px] top-0 ${isMobile ? 'left-0' : 'left-[85px]'} grid ${started ? 'grid-cols-3' : 'grid-cols-2'} divide-x`}
    >
      <div className="flex flex-col items-center m-1 border-container-background">
        <span className="text-base font-bold">{gridsToday}</span>
        <span className="text-xs">grile azi</span>
      </div>
      <div className="flex flex-col items-center m-1 border-container-background">
        <span className="text-base font-bold">{correctGridsString}</span>
        <span className="text-xs">corecte</span>
      </div>
      {started ? (
        <div
          onClick={closeSession}
          className="flex flex-col items-center m-1 border-container-background hover:cursor-pointer"
        >
          <span className="text-xs m-auto text-center hover:brightness-50">
            Închide sesiunea
          </span>
        </div>
      ) : null}
    </div>
  ) : null
}

export default StatsBanner
